<template>
	<UserRegistrationLayout showProgressBar>
		<div class="title-container">Install the Ply extension for Chrome</div>
		<ChromeExtensionSVG class="my-8" />
		<div class="description-text">You’ll be redirected here after you do.</div>
		<AnemicButton class="chrome-store-button" data-cy="registration-username" @click="goToChromeStore">
			<SIcon name="chrome" class="mr-2 mt-1" />
			Go to the Chrome Store
		</AnemicButton>
		<div class="skip-extension-container flex-row flex-end--center">
			<div class="skip-extension-text-container" @click="openPrivacyAndSecurityDialog">Skip</div>
		</div>
	</UserRegistrationLayout>
</template>

<script>
import { mapGetters } from 'vuex';
import ChromeExtensionSVG from './assets/ChromeExtensionSVG';
import UserRegistrationLayout from './UserRegistrationLayout.vue';
import UserRegistrationMixin from './helpers/UserRegistrationMixin';
import UserRegistrationService from './helpers/UserRegistrationService';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';

export default {
	name: 'InstallExtensionLink',
	components: {
		UserRegistrationLayout,
		ChromeExtensionSVG,
	},
	mixins: [UserRegistrationMixin],
	computed: {
		...mapGetters(['user']),
	},
	methods: {
		nextPage() {
			const { signup_referrer } = this.user?.profile?.metadata;
			this.navigateTo({ path: UserRegistrationService.getExtensionFirstPageAfterSignup(signup_referrer, this.$route.query.return_to) });
		},
		skipExtensionInstallation() {
			this.nextPage();
		},
		goToChromeStore() {
			const { VUE_APP_CHROME_EXTENSION_APP_URL: chromeAppURL } = process.env;
			window.open(chromeAppURL, '_blank');
			this.nextPage();
		},
		openPrivacyAndSecurityDialog() {
			AppDialogManagerService.openPrivacyAndSecurityDialog({
				skipExtensionMode: true,
				goToChromeStore: this.goToChromeStore,
				onSkip: this.skipExtensionInstallation,
			});
		},
	},
	data: () => ({}),
};
</script>

<style scoped lang="scss">
.skip-extension-container {
	width: 100%;
	right: -50px;
	bottom: -20px;
	position: relative;

	.skip-extension-text-container {
		width: 200px;
		font-size: 14px;
		text-align: right;
		text-decoration: underline;
		cursor: pointer !important;
		color: var(--primary-font-color);
	}
}
.title-container {
	font-size: 20px;
	margin-top: 30px;
	font-weight: bold;
	background: var(--bg-color);
	color: var(--primary-font-color);
}
.description-text {
	font-size: 12px;
	color: var(--primary-font-color);
}

.chrome-store-button {
	height: 45px;
	padding: 0px;
	font-size: 14px !important;
	color: var(--bg-color);
	border: 1px solid var(--bg-color);
	background: var(--bold-border-color) !important;
	margin: 22px 0px 40px 0px;
}
</style>
